'use strict';

import homeTemplate from './home.html';

var homeController = function() {
}

homeController.$inject = [];

export var homeComponent = {
    name: 'home',
    template: homeTemplate,
    controller: homeController,
    controllerAs: 'vm'
};

export var homeRoute = {
    name: 'home',
    url: '/home',
    component: 'home'
};